const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.company_holidays/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.company_holidays/LIST_COMPANY_HOLIDAYS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        ...action.response.pagination,
      };
    case 'table.company_holidays/LIST_COMPANY_HOLIDAYS_FILTERS_SUCCESS':
      return {
        ...state,
        filters: action.response.filters,
      };
    default:
      return state;
  }
}
